import React from 'react'
import './TopNList.css'
import { QuestionTopNItem } from '../../../service/api/knowledge'
interface TopNListProps {
    dataSource?: QuestionTopNItem[]
    onItemClick?: (item: QuestionTopNItem) => void
}
const TopNList: React.FC<TopNListProps> = (props) => {
    const { dataSource = [], onItemClick = () => undefined } = props
    return (
        <div className='topn-list'>
            <p className='topn-list__title'>推荐知识</p>
            <div className='topn-list-items'>
                {dataSource.map((item, index) => (
                    <div
                        key={item.recId}
                        className='topn-list-item'
                        onClick={() => onItemClick(item)}
                    >
                        <p
                            className={`topn-list-item__index index_${
                                index + 1
                            }`}
                        >
                            {index + 1}
                        </p>
                        <p className='topn-list-item__question'>
                            {item.knowledgeInfo.title}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TopNList
